import { Grid } from '@mui/material';
import type { GridProps, GridSize } from '@mui/material';
import type { PpWC } from '@noah-labs/fe-shared-ui-shared';

export type PpFormItem = Pick<GridProps, 'sx'> &
  PpWC & {
    xs?: GridSize;
  };

export function FormItem({ children, sx, xs = 12 }: PpFormItem): React.ReactElement {
  return (
    <Grid size={{ xs }} sx={sx}>
      {children}
    </Grid>
  );
}
